import React, { useContext, useEffect, useRef, useState } from "react";
import GloblePopup from "../common/GloblePopup";
import { GlobalContext } from "../global/GlobalProvider";
import config from "../config";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

export default function ChangePassword({isStackOpen, handleClose,isPasswordChange}) {
  const { t, i18n } = useTranslation();
  const { setAlertMsg, openSuccessPopup, openErrorPopup,setStackList,isLoggedOut } = useContext(GlobalContext);
  const token = sessionStorage.getItem("token");
  const [showPassword, setShowPassword] = useState(false);
  const [newPasswordShow, setNewPasswordShow] = useState(false);
  const [confPasswordShow, setConfPasswordShow] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();
  
  const togglePasswordVisibility = (type) => {
    if (type === "old") {
      setShowPassword(!showPassword);
    } else if (type === "new") {
      setNewPasswordShow(!newPasswordShow);
    } else {
      setConfPasswordShow(!confPasswordShow);
    }
  };

  const handleLogout = (flag) => {
    const token = sessionStorage.getItem('token');
    sessionStorage.clear();

    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };
    fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/auth/logOutworld`, requestOptions)
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.error(error));
    isLoggedOut();
    getStackListAPI();
    openSuccessPopup();
    setAlertMsg("Logout Successful!");
    isLoggedOut();
    if (flag) {
      navigate("/");
    }

  };

  const getStackListAPI = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    if (sessionStorage.getItem("token")) {
      myHeaders.append("Authorization", `Bearer ${sessionStorage.getItem("token")}`);
    }

    const raw = JSON.stringify({
      whiteLabelName: config.WhiteLable,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${process.env.REACT_APP_BASE_URL}/getStakeLabes2`, requestOptions)
      .then(async (response) => {
        let paresData = await response.json();
        sessionStorage.setItem("stackList", JSON.stringify(paresData.data))
        setStackList(JSON.stringify(paresData.data))
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const callChangePassword = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    const raw = JSON.stringify({
      oldPass: oldPassword,
      newPass: newPassword,
      confPass: confirmPassword,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/users/updateCurrentUserPass`,
      requestOptions
    )
      .then(async (response) => {
        let paresData = await response.json();
        if (paresData.status === "Error") {
          openErrorPopup();
          setAlertMsg(paresData.message)
        } else {
          openSuccessPopup();
          setAlertMsg('Password Change Successfully!!');
          if(isPasswordChange){
            sessionStorage.setItem('passwordchanged',false)
            setOldPassword('');
            setNewPassword('');
            setConfirmPassword('');
            handleClose();
          }
          setOldPassword('');
          setNewPassword('');
          setConfirmPassword('');
          handleClose();
          handleLogout(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleChangePass = () => {
    if (!oldPassword) {
      openErrorPopup(true);
      setAlertMsg("Old password is required");
      return;
    }
    if (!newPassword) {
      openErrorPopup(true);
      setAlertMsg("New password is required");
      return;
    }
    if (!confirmPassword) {
      openErrorPopup(true);
      setAlertMsg("Confirm password is required");
      return;
    }
    if (newPassword !== confirmPassword) {
      openErrorPopup(true);
      setAlertMsg("New password and confirm password do not match");
      return;
    }

    callChangePassword();
  };

  const handleCLOSE = () => {
    if(!isPasswordChange || sessionStorage.getItem('passwordchanged') === 'false'){
      handleClose();
      setOldPassword('');
      setNewPassword('');
      setConfirmPassword('');
    }
  }

  return (
    <GloblePopup
      isOpen={isStackOpen}
      onClose={handleCLOSE}
      title={t('Change Password')}
      className="change-password-modal"
      cancelText="Close"
    >
      <div className="login-form">
        <div className="form-group">
          <label className="user-email-text">{t('Old Password')}</label>
          <div className="input-group">
            <input type={showPassword ? "text" : "password"}
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                  autoComplete="new-password" name="password" className="form-control"/>
            <div className="input-group-append">
              <button type="button" onClick={() => togglePasswordVisibility("old")}
               className="btn btn-secondary password-visible">
                <i className={`fas fa-solid ${ showPassword ? "fa-eye" : "fa-eye-slash" }`} ></i>
              </button>
            </div>
          </div>
        </div>
        <div className="form-group">
          <label className="user-email-text">{t('New Password')}</label>
          <div className="input-group">
            <input
                  type={newPasswordShow ? "text" : "password"}
                  value={newPassword}
                  autoComplete="new-password" name="password"
                  onChange={(e) => setNewPassword(e.target.value)}
                  className="form-control"/>
            <div className="input-group-append">
              <button type="button" onClick={() => togglePasswordVisibility("new")} className="btn btn-secondary password-visible">
              <i className={`fas fa-solid ${ newPasswordShow ? "fa-eye" : "fa-eye-slash" }`} ></i>
              </button>
            </div>
          </div>
        </div>
        <div className="form-group">
          <label className="user-email-text">{t('Confirm Password')}</label>
          <div className="input-group">
            <input autoComplete="new-password" name="password"
                  type={confPasswordShow ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="form-control"/>
            <div className="input-group-append">
              <button type="button" onClick={() => togglePasswordVisibility("conf")} className="btn btn-secondary password-visible">
              <i className={`fas fa-solid ${ confPasswordShow ? "fa-eye" : "fa-eye-slash" }`} ></i>
              </button>
            </div>
          </div>
        </div>
        <div className="form-group">
          <button className="btn btn-primary btn-block" onClick={handleChangePass} >{t('Change Password')}</button>
        </div>
      </div>
    </GloblePopup>
  );
}
